import React, { useState } from "react";
import { BaseModal } from "./BaseModal";
import { TextInput, TextArea, DateInput } from "./InputGroup";
import { Checklist } from "./Checklist";
import "./TaskModal.css";

interface TaskModalProps {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  leftOffset?: number;
  onTaskAdded: (activity: { icon: string; time: string; text: string }) => void;
}

const TaskModal: React.FC<TaskModalProps> = ({
  open,
  onClose,
  onOpen,
  leftOffset,
  onTaskAdded
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [assigned, setAssigned] = useState("");
  const [error, setError] = useState("");
  const [checklistItems, setChecklistItems] = useState<string[]>([]);

  // Task recommendations for the care industry
  const taskRecommendations = [
    {
      title: "Termin vorbereiten",
      description: "Termin mit Kunden vorbereiten und alle notwendigen Unterlagen zusammenstellen. \nCheckliste: \n- Pflegevertrag erstellen\n- Vertrag zusenden\n- Raum reservieren"
    },
    {
      title: "Vertrag zusenden",
      description: "Pflegevertrag an Kunden versenden und auf Rückmeldung warten"
    },
    {
      title: "Unterlagen anfordern",
      description: "Notwendige Unterlagen vom Kunden anfordern (Versicherungsnachweis, Gesundheitsdaten etc.)"
    },
    {
      title: "Pflegebedarf ermitteln",
      description: "Pflegegrad und konkreten Pflegebedarf des Kunden ermitteln und dokumentieren"
    },
  ];

  const handleRecommendationSelect = (recommendation: { title: string; description: string }) => {
    setTitle(recommendation.title);
    setDescription(recommendation.description);
  };

  // Liste der verfügbaren Mitarbeiter
  const employees = [
    "Peter Meier",
    "Petra Schmidt",
    "Peter Schneider",
    "Hans Schmidt",
    "Maria Müller"
  ];




  const handleCreateTask = () => {
    if (!title.trim()) {
      setError("Bitte einen Titel eingeben");
      return;
    }
    if (!assigned) {
      setError("Bitte einen zuständigen Mitarbeiter auswählen");
      return;
    }

    const newActivity = {
      icon: "fa-solid fa-tasks",
      time: new Date().toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" }),
      text: `Aufgabe: ${title}`,
      detail: `Zuständig: ${assigned} | Frist: ${dueDate}`
    };

    onTaskAdded(newActivity);
    // Reset state
    [setTitle, setDescription, setDueDate, setAssigned, setError].forEach(fn => fn(""));
    onClose();
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      leftOffset={leftOffset}
      headerText="Aufgabe erstellen"
      className="task-modal"
    >

      <TextInput
        label="Aufgabentitel:"
        value={title}
        onChange={setTitle}
        placeholder="Titel eingeben"
        error={error}
      />

      <TextArea
        label="Beschreibung:"
        value={description}
        onChange={setDescription}
        placeholder="Beschreibung eingeben"
      />

      <DateInput
        label="Frist:"
        value={dueDate}
        onChange={setDueDate}
      />

      <div className="input-group">
        <label htmlFor="assigned-select">Zuständiger Mitarbeiter:</label>
        <select
          id="assigned-select"
          value={assigned}
          onChange={(e) => setAssigned(e.target.value)}
        >
          <option value="">Bitte auswählen</option>
          {employees.map((employee, idx) => (
            <option key={idx} value={employee}>
              {employee}
            </option>
          ))}
        </select>
      </div>

      <div className="modal-actions">
        <button onClick={handleCreateTask}>Erstellen</button>
      </div>


      {/* Task Recommendations Section */}
      <div className="task-recommendations" style={{ marginTop: "20px" }}>
        <label>Passende Aufgaben:</label>
        <div className="recommendations-grid">
          {taskRecommendations.map((recommendation, index) => (
            <div
              key={index}
              className="recommendation-item"
              onClick={() => handleRecommendationSelect(recommendation)}
              title={recommendation.description}
            >
              <div className="recommendation-icon">💡</div>
              <div className="recommendation-text">{recommendation.title}</div>
            </div>
          ))}
        </div>
      </div>

    </BaseModal>
  );
};

export default TaskModal;
